<template>
  <div class="table">
    <!-- 表格标题栏 -->
    <div class="title">
      <div class="title-total">
        <div>{{$t('foundationTable.title')}}</div>
      </div>
      <!-- <div class="page-con">
        <Page :total="total" :page-size="pageSize" show-elevator/>
      </div>-->
    </div>
    <!-- 表格 -->
    <div class="real-table">
      <!-- 表头 -->
      <div class="head">
        <div>{{$t('foundationTable.indexTitle')}}</div>
        <div>{{$t('foundationTable.addressTitle')}}</div>
        <div>{{$t('foundationTable.balanceTitle')}}</div>
      </div>
      <!-- 骨架 -->
      <div v-if="isLoading">
        <div class="body" v-for="item in pageSize" :key="item">
          <div>{{item}}</div>
          <div>
            <router-link to="/">-</router-link>
          </div>
          <div>-</div>
        </div>
      </div>
      <!-- 表身 -->
      <div class="body" v-for="(item, index) in tableData" :key="index">
        <div>{{index + 1}}</div>
        <div>
          <router-link :to="'/accountDetails?account=' + item.address">{{item.address}}</router-link>
        </div>
        <div>{{formatToken(item.balance)}}</div>
      </div>
      <dna-spin v-if="isLoading"></dna-spin>
    </div>
  </div>
</template>

<script>
import util from "@/util/util.js";
import req from "@/req/req.js";
export default {
  data() {
    return {
      tableData: [],
      page: 1,
      pageSize: 15,
      isLoading: true,
      total: 0,
    };
  },
  methods: {
    formatNumeral(val) {
      return util.formatNumeral(val, this.$t("numeral.symbols"));
    },
    formatToken(val) {
      return util.formatToken(val, []);
    },
  },
  async mounted() {
    let data = await req.fetchFoundation(this.page, this.pageSize);
    console.log(data);
    this.total = data.total;
    let tempList = [];
    for (let i in data.foundations) {
      let temp = {
        address: data.foundations[i].account_name,
        balance: data.foundations[i].balance,
      };
      tempList.push(temp);
    }
    this.tableData = tempList;
    this.isLoading = false;
  },
};
</script>

<style lang="less" scoped>
@import url("./FoundationTable.less");
</style>